// extracted by mini-css-extract-plugin
export default {"notFoundMessage":"CountriesList_notFoundMessage__NCGIo","wrap":"CountriesList_wrap__PWA1+","list":"CountriesList_list__UIsAc"};